import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";

const threads = [
  { source: "Reddit", seen: "last reply 11 days ago", title: "Reddit threads disappear.", body: "You post, get three DMs, one replies. By week two, silence." },
  { source: "Discord", seen: "last online 3 weeks ago", title: "Discord partners ghost.", body: "The novelty fades. So does their username." },
  { source: "Group chat", seen: "seen, no reply", title: "Friends aren’t always committed.", body: "They love you. They also love their couch." },
  { source: "Habit app", seen: "streak reset 4 times", title: "Productivity apps can’t replace people.", body: "A streak counter has never once asked how you’re doing." },
];

// The failure modes literally ghost as you scroll past them.
export default function GhostFeed() {
  return (
    <ol className="border-t border-white/[0.08]">
      {threads.map((t, i) => <GhostRow key={t.title} thread={t} index={i} />)}
    </ol>
  );
}

function GhostRow({ thread, index }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const opacity = useTransform(scrollYProgress, [0, 0.55, 0.9], [1, 1, 0.22]);
  const blur = useTransform(scrollYProgress, [0.55, 0.9], ["blur(0px)", "blur(2.5px)"]);
  const strike = useTransform(scrollYProgress, [0.42, 0.62], ["0% 4px", "100% 4px"]);

  return (
    <motion.li
      ref={ref}
      data-testid={`problem-card-${index}`}
      style={reduce ? undefined : { opacity, filter: blur }}
      className="group py-8 sm:py-10 border-b border-white/[0.08]"
    >
      <h3 className="font-serif-editorial text-3xl sm:text-4xl leading-[1.08] text-[#F5F5F0]">
        <motion.span className="ghost-strike" style={{ backgroundSize: reduce ? "100% 4px" : strike }}>
          {thread.title}
        </motion.span>
      </h3>
      <p className="mt-3 max-w-lg text-[15px] text-[#A1A1AA] font-light leading-relaxed">{thread.body}</p>
      <p className="mt-4 flex items-center gap-2 text-xs text-[#8a8a92] tabular-nums">
        <span className="w-1.5 h-1.5 rounded-full bg-[#4a4a50]" aria-hidden="true" />
        {thread.source} · {thread.seen}
      </p>
    </motion.li>
  );
}
